// React
import type { PropsWithChildren } from "react"

// Components
import { Button } from "components"

// Types
import type { DataType } from "../types"

// Utils
import { ErrorType, exportFile } from "../utils"

export function ActionButton(params: PropsWithChildren<{
  data: DataType[]
  error: ErrorType[]
  index: number
  onStartImport: () => void
}>): JSX.Element {
  // Vars
  const { data, error, index } = params
  return (
    <div className="flex flex-col gap-3">
      <section className="flex justify-end gap-3">
        {Boolean(index >= data.length && error.length) ? (
          <Button
            color="primary"
            onClick={() => {
              // Vars
              const failedData: { [key: string]: string | number | null }[] = data.filter((_, key) => {
                return error.map(item => item.index).includes(key)
              }).map(item => {
                return {
                  height: item.height,
                  length: item.length,
                  main_size: item.main_size,
                  mr_category_customer: item.mr_category_customer,
                  mr_product_category: item.mr_product_category,
                  mr_product_colour: item.mr_product_colour,
                  mr_product_group: item.mr_product_group,
                  mr_product_material: item.mr_product_material,
                  mr_product_style: item.mr_product_style,
                  product_barcode: item.product_barcode,
                  product_name: item.product_name,
                  weight: item.weight,
                  weight_unit: item.weight_unit,
                  width: item.width
                }
              })

              exportFile(failedData)
            }}
          >
            DOWNLOAD FAILED DATA
          </Button>
        ) : (
          <></>
        )}

        <Button
          color="primary"
          disabled={index !== -1}
          onClick={params.onStartImport}
        >
          {index === -1 || index >= data.length - 1 ? "START IMPORT" : `PROCESSING (${index + 1}/${data.length})`}
        </Button>
      </section>

      {params.children}
    </div>
  )
}